@if (isLoaded) {
  <div class="finance-authorization">
    <span
      class="finance-authorization-badge"
      [class.is-blocked]="isBlocked"
      [ngbTooltip]="tooltipText"
      placement="bottom"
      tabindex="0">
      <span class="finance-authorization-dot"></span>
      {{ badgeLabel }}
      @if (currentEntry) {
        <i class="fa fa-solid fa-circle-info ms-1"></i>
      }
    </span>

    @if (showOverrideButton) {
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        [disabled]="isSaving"
        (click)="openOverrideModal()">
        @if (overrideAction === 'MANUAL_UNLOCK') {
          <i class="fa fa-solid fa-lock-open me-1"></i>Unlock manually
        } @else {
          <i class="fa fa-solid fa-lock me-1"></i>Lock manually
        }
      </button>
    }
  </div>
}

<ng-template #overrideModal>
  <div class="modal-header">
    <h5 class="modal-title">
      @if (overrideAction === 'MANUAL_UNLOCK') {
        <i class="fa fa-solid fa-lock-open text-success me-2"></i>Unlock Finance authorization
      } @else {
        <i class="fa fa-solid fa-lock text-danger me-2"></i>Lock Finance authorization
      }
    </h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="isSaving" (click)="closeOverrideModal()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-3">{{ overrideMessage }}</p>
    <textarea-field
      label="Reason"
      placeholder="Explain why the Finance authorization is being changed manually"
      [textareaFormControl]="reasonControl"
      [readonly]="false"
      [height]="120">
    </textarea-field>
  </div>
  <div class="modal-footer d-flex justify-content-between align-items-center">
    <button type="button" class="btn btn-secondary" [disabled]="isSaving" (click)="closeOverrideModal()">Back</button>
    <button type="button" class="btn btn-primary" [disabled]="isSaving || reasonControl.invalid" (click)="confirmOverride()">
      Confirm
    </button>
  </div>
</ng-template>
